// MachineUtilizationDashboard/components/DashboardSection.jsx

function DashboardSection({
  eyebrow,
  title,
  description,
  action = null,
  children,
  className = "",
}) {
  return (
    <section className={`mud-section ${className}`}>
      <div className="mud-section__header">
        <div>
          {eyebrow && <span className="mud-section__eyebrow">{eyebrow}</span>}

          <h3>{title}</h3>

          {description && <p>{description}</p>}
        </div>

        {action && <div className="mud-section__action">{action}</div>}
      </div>

      <div className="mud-section__body">{children}</div>
    </section>
  );
}

export default DashboardSection;